export default "__VITE_ASSET__Pqil6iZT__"